import styled from 'styled-components';

export const Content = styled.div``;

/*
 * The cell wrapper the renderers hand back. AppTable clips it and puts the
 * full value on the cell's title, so it carries alignment and nothing else.
 *
 * What used to be here as well: a #f7f8fc / 12px-radius toolbar box (now
 * components/toolbar), a #8a93ac pill button and a 40px #616e84 avatar
 * circle, none of which this table rendered any more.
 */
export const Div = styled.div`
  &.captal {
    text-transform: capitalize;
  }
`;
